function roundToFixedAndParseFloat(value, fixedSize) {
  return parseFloat(value.toFixed(fixedSize));
}

function formatRatePlanAmount(value) {
  return (+value.toFixed(1)).toString();
}

function formatNumberWithFixed(value, fixedSize) {
  return parseFloat(value).toFixed(fixedSize);
}

export { roundToFixedAndParseFloat, formatRatePlanAmount, formatNumberWithFixed };
